/**
 * Bottom sheets for preferences flow (menu, fund list, learn more).
 *
 * Belongs here: sheet UI.
 * Does not belong here: navigation impl.
 */
import { useEffect } from 'react'
import BottomSheetContent from '../../../../../../components/BottomSheetComponents/BottomSheetContent'
import { PrimaryButton } from '../../../../../../components/execution/PrimaryButton'
import { SecondaryButton } from '../../../../../../components/execution/SecondaryButton'
import { EventNames } from '../../../../../../types/misc.types'
import { lightImpactVibrate, trackEvent } from '../../../../../../utils/appBridge'
import { ExpertReviewBottomSheet, ExpertReviewEventIds } from '../../../analytics/expertReviewEvents'

interface PreferencesMenuSheetProps {
  analyticsScreen: string
  onDismiss: () => void
  onExitPreferences: () => void
}

export function PreferencesMenuSheet({
  analyticsScreen,
  onDismiss,
  onExitPreferences,
}: PreferencesMenuSheetProps) {
  useEffect(() => {
    trackEvent({
      eventName: EventNames.BottomSheetLoad,
      payload: {
        ScreenName: analyticsScreen,
        eventId: ExpertReviewBottomSheet.PreferencesMenu,
        bottomSheetName: ExpertReviewBottomSheet.PreferencesMenu
      }
    })
  }, [analyticsScreen])

  const handleExit = () => {
    lightImpactVibrate()
    trackEvent({
      eventName: EventNames.UserClicked,
      payload: {
        ScreenName: analyticsScreen,
        eventId: ExpertReviewEventIds.MenuExit,
        buttonLabel: 'Exit Preferences'
      }
    })
    onDismiss()
    onExitPreferences()
  }

  const handleGoBack = () => {
    lightImpactVibrate()
    trackEvent({
      eventName: EventNames.UserClicked,
      payload: {
        ScreenName: analyticsScreen,
        eventId: ExpertReviewEventIds.MenuGoBack,
        buttonLabel: 'Go back'
      }
    })
    onDismiss()
  }

  const ctas = (
    <div className='flex flex-col gap-3 px-5 pb-2'>
      <SecondaryButton
        testLocator='preferences-menu-exit'
        label='Exit Preferences'
        onClick={handleExit}
        secondaryButtonClassName='!h-14 !rounded-xl'
      />
      <PrimaryButton
        testLocator='preferences-menu-go-back'
        label='Go back'
        onClick={handleGoBack}
        primaryButtonClassName='!h-14 !rounded-xl'
      />
    </div>
  )

  return (
    <BottomSheetContent
      onDismiss={onDismiss}
      bottomSheetHeadClassName='!py-0'
      bottomSheetBodyClassName='!px-0'
      bottomSheetCtas={ctas}
      bottomSheetCtaClassName='!pt-1 !px-0'
      bottomSheetCtaWrapperClassName='!px-0'
    >
      <div />
    </BottomSheetContent>
  )
}
